export default __webpack_public_path__ + "static/media/OnCourse_Logo.72157286.svg";